import { BuilderTypes } from '@frontend/forms-builder-engine';

export function convertToCategorizedChecklist(
  checklist: BuilderTypes.FieldTypes.Field
): BuilderTypes.FieldTypes.CategorizedOptionsField {
  const categorizedChecklist: BuilderTypes.FieldTypes.CategorizedOptionsField = {
    label: checklist.label,
    meta: {
      ...checklist.meta,
      type: 'categorizedChecklist',
    },
    categories: [],
  };

  return categorizedChecklist;
}
